import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import { booksChapter, checkSubscription } from '../../Services/Subscription';
import { useSelector } from 'react-redux';
import { getReadBook } from '../../Services/BooksServices';

const useBooks = () => {


    const location = useLocation();
    const item = location.state?.data;
    const [checkSubs, setCheckSubs] = useState(null)
    const [bookschap, setBookschap] = useState(null)
    const [read, setRead] = useState(false)

    const { token } = useSelector((state) => state.auth);


    const handleCheckSubscription = async () => {
        // setIsLoading(true)
        if (token) {
            let response = await checkSubscription()
            if (response.statusCode === 200) {
                setCheckSubs(response?.response?.data)
                // setIsLoading(false)
            } else if (response.statusCode === 401) {
                toast?.error(response?.errors)
                // setIsLoading(false)
            } else {
                for (const [key, value] of Object.entries(response?.errors)) {
                    toast?.error(value)
                }
                // setIsLoading(false)
            }
            // setIsLoading(false)

        }
    }

    const handleChapters = async () => {
        // setIsLoading(true)
        let response = await booksChapter(item?.id)
        if (response.statusCode === 200) {
            // return console.log("response=>", response?.response?.data)
            setBookschap(response?.response?.data)
            // setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            // setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            // setIsLoading(false)
        }
        // setIsLoading(false)
    }



   

    useEffect(() => { handleCheckSubscription() }, [])
    useEffect(() => { handleChapters() }, [])


    return {
        item,
        checkSubs,
        bookschap,
        read,
        setRead,
        token
    }
}

export default useBooks